// Modified by Sullivan Digital, 2026-10-26: removes the Metabase store link (SALDP white-labelling). Licensed under the GNU AGPL v3.
import { t } from "ttag";

import { ExternalLink } from "metabase/common/components/ExternalLink";
import { removedUpsell } from "metabase/common/components/upsells/components/removed-upsell";
import { Flex, Icon, Tooltip } from "metabase/ui";

import S from "./StoreLink.module.css";

const StoreLink = () => {
  return (
    <Tooltip label={t`Explore paid features`}>
      <ExternalLink
        href="https://metabase.com/upgrade"
        data-testid="store-link"
        className={S.root}
      >
        <Flex align="center" justify="center" className={S.iconWrapper}>
          <Icon name="store" size={20} />
        </Flex>
      </ExternalLink>
    </Tooltip>
  );
};

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default removedUpsell(StoreLink);
